const toText = (value) => String(value ?? '');

// Keep word checks forgiving about casing, punctuation and extra spaces—the
// previous vocabulary flow already treated these variants as the same answer.
export const normalizeAnswer = (value) => toText(value)
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '');

export const answersMatch = (answer, expected) =>
    normalizeAnswer(answer) === normalizeAnswer(expected);

const normalizePhrase = (value) => toText(value)
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()
    .replace(/\s+/g, ' ');

/**
 * Matches complete words (or a complete multi-word form), so a form such as
 * "art" does not accidentally match the word "article".
 */
export const sentenceContainsForm = (answer, form) => {
    const phrase = normalizePhrase(form);
    const sentence = normalizePhrase(answer);

    return Boolean(phrase) && ` ${sentence} `.includes(` ${phrase} `);
};
